export default {
  CLEAR: "clear",
  WAIT: "wait",
  EXPIRED: "expired",
  OVERPAY: "overpay",
  WAITING_LABOR_OFFICE: "waiting_labor_office",
  PAID: "paid",
};
